import { useMemo } from 'react';
import type { ApiRequestInit } from './api.js';
import { useAuth } from '../auth/AuthContext.js';

/** Per-request tenant context for master admins without a top-bar scope chip. */
export function masterScopedRequest(
  tenantId: string | null | undefined,
): ApiRequestInit | undefined {
  if (!tenantId) return undefined;
  return {
    skipTenantScope: true,
    headers: { 'x-tenant-context': tenantId },
  };
}

/** Scope opts for master admins using an explicit tenant page/query context. */
export function useMasterPerRequestScope(
  tenantId: string | null | undefined,
): ApiRequestInit | undefined {
  const { state } = useAuth();
  const needsPerRequest =
    state.status === 'authed' &&
    state.user.role === 'master_admin' &&
    state.user.tenant_id == null;
  return useMemo(
    () => (needsPerRequest ? masterScopedRequest(tenantId) : undefined),
    [needsPerRequest, tenantId],
  );
}
